export default "__VITE_ASSET__BWL2uLYE__"